import { CardDrop } from '../../../../../../shared/components/cards/card-drop/CardDrop'
import React, { PropsWithChildren } from 'react'
import { ProfileIcon } from '../../../../../../shared/components/icons/nav/ProfileIcon'

export const ProfileDropdown = ({ children }: PropsWithChildren) => {
  return (
    <CardDrop
      trigger={
        <div className={'relative flex items-center rounded-[18px] border border-aqua-300 p-[2px]'}>
          <div className='flex h-[32px] w-[32px] items-center justify-center rounded-full hover:bg-[#6684A74D]'>
            <span className={'text-white'}>
              <ProfileIcon />
            </span>
          </div>
        </div>
      }
      className={'!top-[50px]'}
    >
      <div className={'flex min-w-[150px] flex-col gap-[8px] p-[16px]'}>{children}</div>
    </CardDrop>
  )
}
